import "./myPrescriptions.scss";
import React from "react";
import { Box, Container } from "@mui/material";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
import { FormPrescription } from "../../../components/doctor/my-prescriptions/form-prescription";

const NewPrescription = () => {

  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <FormPrescription action="new" />
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default NewPrescription;
